class ListController {
    public onUpdate: any;
    public list: any;
    public currentPage: number;
    public itemsPerPage: number;
    public maxSize: number;
    public hideDelete: boolean;

    private fields: any;
    private setFields: any;

    constructor(private SweetAlert: any) {
        'ngInject';
    }

    $onInit = () => {
        this.currentPage = 1;
        this.itemsPerPage = 25;
        this.maxSize = 3;

        var setFields = { description: null }
        if (this.fields) {
            this.fields = JSON.parse(this.fields.replace(/\'/g, '"'));
        } else {
            this.fields = {}
        }

        this.setFields = {
            description: this.fields.description ? this.fields.description : 'description',
            tags: this.fields.tags ? this.fields.tags : 'tags',
            date: this.fields.date ? this.fields.date : 'date',
            endDate: this.fields.endDate ? this.fields.endDate : 'endDate' 
        };
    }

    public delete(event, item) {
        event.stopPropagation();
        this.SweetAlert.swal({
            title: 'Let op!',
            text: 'Weet u zeker dat u '+ item[this.setFields.description] +' wilt verwijderen?',
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#2ECC71',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ja',
            cancelButtonText: 'Nee, annuleren',
        }, (isConfirm) => {
            if (isConfirm) {
                this.onUpdate({ item: item, action: 'delete' });
            } else {

            }
        });        
      
    }

    public edit(item) {
        this.onUpdate({ item: item, action: 'edit' });
    }
}

export const listComponent = {
    bindings: {
        list: '<',
        onUpdate: '&',
        fields: '@',
        hideDelete: '<'
    },
    controller: ListController,
    template: require('./list.html')
};



// WEBPACK FOOTER //
// ./src/app/modules/shared/list.component.ts